const zIndex = {
    // ordered from highest to lowest
    staticToast: 999999,
};

export default zIndex;
